import React from 'react';
import { BsSearch, BsArrowLeftShort } from "react-icons/bs"; // Confirmados en tu lista de errores

const L2NoResultsComponent = ({ searchText }) => {
  return (
    <div className="container mt-5 mb-5 animate__animated animate__fadeIn">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 col-lg-6 text-center p-5 shadow-sm rounded-4 bg-white border">
          
          {/* Icono de Lupa */}
          <div className="d-inline-flex align-items-center justify-content-center mb-4" 
               style={{ 
                 width: '100px', 
                 height: '100px', 
                 borderRadius: '50%', 
                 backgroundColor: '#f8f9fa' 
               }}>
            <BsSearch size={40} className="text-muted" />
          </div>
          
          <h3 className="fw-bold text-dark mb-2">Sin coincidencias</h3>
          <p className="text-muted">
            No encontramos resultados para: <br />
            <strong className="text-primary">"{searchText}"</strong>
          </p>
          
          <div className="alert alert-light border mt-4" role="alert">
            <small className="text-uppercase fw-bold d-block mb-2 text-secondary" style={{ fontSize: '0.7rem' }}>
              Sugerencias
            </small>
            <ul className="list-unstyled mb-0 small text-secondary">
              <li>• Revisa si hay errores tipográficos.</li>
              <li>• Prueba con términos menos específicos.</li>
              <li>• Intenta buscar por una sola palabra clave.</li>
            </ul>
          </div>

          <button 
            className="btn btn-outline-primary rounded-pill mt-4 px-4 d-inline-flex align-items-center"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <BsArrowLeftShort size={24} /> Volver a intentar
          </button>
        </div>
      </div>
    </div>
  );
};

export default L2NoResultsComponent;